export enum ResponseMessages {
    SUCCESS = "success",
    DANGER = "danger",
    WARNING = "warning",
}
